/* ============================================================
   Gymazing Wishlist – localStorage-based, no app needed
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'gymazing_wishlist';

  /* ── helpers ── */
  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function save(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  function has(id) {
    return get().some(function (i) { return String(i.id) === String(id); });
  }

  function toggle(data) {
    var list = get();
    var idx = list.findIndex(function (i) { return String(i.id) === String(data.id); });
    if (idx > -1) { list.splice(idx, 1); } else { list.push(data); }
    save(list);
    syncUI();
  }

  function remove(id) {
    var list = get().filter(function (i) { return String(i.id) !== String(id); });
    save(list);
    syncUI();
  }

  /* ── sync every heart + header badge ── */
  function syncUI() {
    var list = get();
    var ids = list.map(function (i) { return String(i.id); });

    document.querySelectorAll('.wl-heart').forEach(function (btn) {
      btn.classList.toggle('wl-heart--active', ids.indexOf(String(btn.dataset.productId)) > -1);
    });

    document.querySelectorAll('.wl-header-badge').forEach(function (badge) {
      badge.textContent = list.length > 0 ? list.length : '';
      badge.style.display = list.length > 0 ? 'flex' : 'none';
    });

    /* fill the header heart when wishlist has items */
    document.querySelectorAll('.wl-header-link').forEach(function (link) {
      var svg = link.querySelector('svg');
      if (!svg) return;
      var path = svg.querySelector('path');
      if (list.length > 0) {
        svg.setAttribute('fill', '#C9A84C');
        svg.setAttribute('stroke', '#C9A84C');
      } else {
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
      }
    });

    /* if wishlist page is open, re-render it */
    if (typeof window.__wlRenderPage === 'function') window.__wlRenderPage();
  }

  /* ── click handler (delegated) ── */
  document.addEventListener('click', function (e) {
    var heart = e.target.closest('.wl-heart');
    if (!heart) return;
    e.preventDefault();
    e.stopPropagation();

    toggle({
      id:     heart.dataset.productId,
      handle: heart.dataset.productHandle,
      title:  heart.dataset.productTitle,
      image:  heart.dataset.productImage,
      price:  heart.dataset.productPrice,
      url:    heart.dataset.productUrl,
      vendor: heart.dataset.productVendor,
      variantId: heart.dataset.productVariant,
      available: heart.dataset.productAvailable
    });
  });

  /* ── init ── */
  function init() { syncUI(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* expose for wishlist page */
  window.GymazingWishlist = { get: get, has: has, toggle: toggle, remove: remove, syncUI: syncUI };
})();
